// extracted by mini-css-extract-plugin
export default {"popper":"styles_popper__6mxeS","container":"styles_container__zvGa2","nowrap":"styles_nowrap__7e0Aa"};